import React from 'react';
import Table from 'components/tables/components/Table';
import {withState} from 'shared/core';
import {TaskTemplateSelectorState} from '../state';
import {observer} from 'mobx-react';
import Assignee from './Assignee';
import DueDateView from './DueDateView';
import AddTaskTemplatesModal from './AddTaskTemplatesModal';
import EditTaskTemplateModal from './EditTaskTemplateModal';
import TaskHiddenFields from './TaskHiddenFields';

const COLUMNS = [
  {
    header: 'tasks.Task Name',
    attribute: 'taskTemplate.name',
    width: 5
  },
  {
    header: 'tasks.Assignee',
    component: Assignee,
    width: 3
  },
  {
    header: 'tasks.Due',
    component: DueDateView,
    width: 3
  }
];

const CUSTOM_LINKS = [
  {
    text: 'Edit',
    action: viewModel => viewModel.uiState.openEditTaskTemplateModal(viewModel.taskTemplate)
  },
  {
    text: 'Remove',
    action: viewModel => viewModel.uiState.unselectTaskTemplate(viewModel.taskTemplate)
  }
];

const TaskList = observer(({uiState}) => {
  const {selectedTaskTemplates, localization, config} = uiState;

  return (
    <div>
      <Table
        uiState={uiState}
        models={selectedTaskTemplates}
        indexBy='taskTemplate.clientId'
        columns={COLUMNS}
        localization={localization}
        onAdd={() => uiState.openAddTaskTemplateModal()}
        customLinks={CUSTOM_LINKS}
      />
      <AddTaskTemplatesModal uiState={uiState}/>
      <EditTaskTemplateModal uiState={uiState}/>
      {config.templateType === 'offboarding' && <TaskHiddenFields taskTemplates={selectedTaskTemplates}/>}
    </div>
  );
});

export default withState(TaskList, TaskTemplateSelectorState);

